import * as e from "react";
import t, { useContext as n, useEffect as r, useState as a } from "react";
import o from "classnames";
import { QueryClient as i, QueryClientProvider as l, useQuery as c } from "react-query";
import { FiEdit as u } from "react-icons/fi";
import s from "axios";

var _d = function d(e, t) {
  return _d = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var n in t) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }, _d(e, t);
};

function p(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

  function n() {
    this.constructor = e;
  }

  _d(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
}

var _m = function m() {
  return _m = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      for (var a in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
      }
    }

    return e;
  }, _m.apply(this, arguments);
};

function f(e, t) {
  var n = {};

  for (var r in e) {
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var a = 0;

    for (r = Object.getOwnPropertySymbols(e); a < r.length; a++) {
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
    }
  }

  return n;
}

function g(e, t, n, r) {
  return new (n || (n = Promise))(function (a, o) {
    function i(e) {
      try {
        c(r.next(e));
      } catch (e) {
        o(e);
      }
    }

    function l(e) {
      try {
        c(r.throw(e));
      } catch (e) {
        o(e);
      }
    }

    function c(e) {
      var t;
      e.done ? a(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
        e(t);
      })).then(i, l);
    }

    c((r = r.apply(e, t || [])).next());
  });
}

function h(e, t) {
  var n,
      r,
      a,
      o,
      i = {
    label: 0,
    sent: function sent() {
      if (1 & a[0]) throw a[1];
      return a[1];
    },
    trys: [],
    ops: []
  };
  return o = {
    next: l(0),
    throw: l(1),
    return: l(2)
  }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
    return this;
  }), o;

  function l(o) {
    return function (l) {
      return function (o) {
        if (n) throw new TypeError("Generator is already executing.");

        for (; i;) {
          try {
            if (n = 1, r && (a = 2 & o[0] ? r.return : o[0] ? r.throw || ((a = r.return) && a.call(r), 0) : r.next) && !(a = a.call(r, o[1])).done) return a;

            switch (r = 0, a && (o = [2 & o[0], a.value]), o[0]) {
              case 0:
              case 1:
                a = o;
                break;

              case 4:
                return i.label++, {
                  value: o[1],
                  done: !1
                };

              case 5:
                i.label++, r = o[1], o = [0];
                continue;

              case 7:
                o = i.ops.pop(), i.trys.pop();
                continue;

              default:
                if (!(a = i.trys, (a = a.length > 0 && a[a.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                  i = 0;
                  continue;
                }

                if (3 === o[0] && (!a || o[1] > a[0] && o[1] < a[3])) {
                  i.label = o[1];
                  break;
                }

                if (6 === o[0] && i.label < a[1]) {
                  i.label = a[1], a = o;
                  break;
                }

                if (a && i.label < a[2]) {
                  i.label = a[2], i.ops.push(o);
                  break;
                }

                a[2] && i.ops.pop(), i.trys.pop();
                continue;
            }

            o = t.call(e, i);
          } catch (e) {
            o = [6, e], r = 0;
          } finally {
            n = a = 0;
          }
        }

        if (5 & o[0]) throw o[1];
        return {
          value: o[0] ? o[1] : void 0,
          done: !0
        };
      }([o, l]);
    };
  }
}

function v(e) {
  var t = "function" == typeof Symbol && Symbol.iterator,
      n = t && e[t],
      r = 0;
  if (n) return n.call(e);
  if (e && "number" == typeof e.length) return {
    next: function next() {
      return e && r >= e.length && (e = void 0), {
        value: e && e[r++],
        done: !e
      };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function y(e, t) {
  var n = "function" == typeof Symbol && e[Symbol.iterator];
  if (!n) return e;
  var r,
      a,
      o = n.call(e),
      i = [];

  try {
    for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) {
      i.push(r.value);
    }
  } catch (e) {
    a = {
      error: e
    };
  } finally {
    try {
      r && !r.done && (n = o.return) && n.call(o);
    } finally {
      if (a) throw a.error;
    }
  }

  return i;
}

function b(e, t, n) {
  if (n || 2 === arguments.length) for (var r, a = 0, o = t.length; a < o; a++) {
    !r && a in t || (r || (r = Array.prototype.slice.call(t, 0, a)), r[a] = t[a]);
  }
  return e.concat(r || Array.prototype.slice.call(t));
}

var E,
    k = e.createContext({
  values: {},
  onChange: function onChange() {},
  blockId: "",
  parentId: "",
  parentType: "",
  handleChange: function handleChange(e) {
    return function () {};
  },
  handleAddItem: function handleAddItem(e) {
    return function () {};
  }
});
!function (e) {
  var t, n, r, a, o, i, l, c, u, s;
  (t = e.SideEditPropType || (e.SideEditPropType = {})).Text = "TEXT", t.Textarea = "TEXTAREA", t.Number = "NUMBER", t.Date = "DATE", t.Range = "RANGE", t.Boolean = "BOOLEAN", t.Select = "SELECT", t.Image = "IMAGE", t.Custom = "CUSTOM", (n = e.OptionsDisplay || (e.OptionsDisplay = {})).Select = "SELECT", n.Radio = "RADIO", n.Color = "COLOR", (r = e.RichTextFeatures || (e.RichTextFeatures = {})).Bold = "BOLD", r.Italic = "ITALIC", r.Code = "CODE", r.Highlight = "HIGHLIGHT", r.Link = "LINK", r.UnorderedList = "UL", r.OrderedList = "OL", r.Heading1 = "H1", r.Heading2 = "H2", r.Heading3 = "H3", r.Heading4 = "H4", r.Heading5 = "H5", r.Heading6 = "H6", r.Quote = "QUOTE", (a = e.SortDirection || (e.SortDirection = {})).Up = "UP", a.Down = "DOWN", (o = e.PageStatus || (e.PageStatus = {})).Draft = "DRAFT", o.Published = "PUBLISHED", (i = e.DeployEnvironment || (e.DeployEnvironment = {})).Staging = "STAGING", i.Production = "PRODUCTION", (l = e.PlaygroundSelectedItemType || (e.PlaygroundSelectedItemType = {})).Block = "BLOCK", l.Page = "PAGE", (c = e.DeviceType || (e.DeviceType = {})).Desktop = "DESKTOP", c.Tablet = "TABLET", c.Phone = "PHONE", (u = e.Tab || (e.Tab = {})).Block = "BLOCK", u.Item = "ITEM", u.PageSettings = "PAGE-SETTINGS", u.Document = "DOCUMENT", u.Stories = "STORIES", (s = e.ClickToEditSide || (e.ClickToEditSide = {})).BottomRight = "BOTTOM-RIGHT", s.BottomLeft = "BOTTOM-LEFT", s.TopRight = "TOP-RIGHT", s.TopLeft = "TOP-LEFT";
}(E || (E = {}));

var T = e.createContext({
  focused: {
    blockId: "",
    itemId: "",
    repeaterPropName: ""
  },
  setFocused: function setFocused() {},
  triggerTextRefreshBlockId: "",
  setTriggerTextRefreshBlockId: function setTriggerTextRefreshBlockId() {},
  setAddAfterBlockId: function setAddAfterBlockId() {},
  pageValues: {
    id: "",
    type: "",
    name: "",
    slug: "",
    meta: {},
    authorId: "",
    author: {
      id: "",
      email: "",
      firstName: "",
      lastName: ""
    },
    invalidBlocksTypes: [],
    status: E.PageStatus.Draft,
    isLocked: !1,
    tags: [],
    createdAt: "",
    publishedAt: "",
    language: "",
    translations: []
  },
  handleChangePageValue: function handleChangePageValue() {}
}),
    x = function x(e) {
  return function (e) {
    var t, n;
    if (!1 === S(e)) return !1;
    if ("function" != typeof (t = e.constructor)) return !1;
    if (!1 === S(n = t.prototype)) return !1;
    if (!1 === n.hasOwnProperty("isPrototypeOf")) return !1;
    return !0;
  }(e) && "string" == typeof e.text;
};

function P(e) {
  return x(e) ? e.text : e.children && Array.isArray(e.children) ? e.children.map(P).join("") : "";
}

function S(e) {
  return !0 == (null != (t = e) && "object" == typeof t && !1 === Array.isArray(t)) && "[object Object]" === Object.prototype.toString.call(e);
  var t;
}

var I,
    w = {
  serialize: function serialize(e) {
    return Array.isArray(e) && e.length > 0 ? e.map(P).join("\n") : "";
  },
  deserialize: function deserialize(e) {
    return e.split("\n").map(function (e) {
      return {
        type: "paragraph",
        children: [{
          text: e
        }]
      };
    });
  },
  isText: x
},
    L = function L(t, n, r) {
  if (w.isText(t)) {
    var a = N(t.text);
    return n.filter(function (e) {
      return "Mark" === e.type;
    }).reduce(function (e, n) {
      return t[n.name] ? n.renderLeaf({
        children: e
      }) : e;
    }, a);
  }

  var o = n.filter(function (e) {
    return "List" === e.type;
  }).find(function (e) {
    return t.type === e.name;
  });

  if (o) {
    var i = C(t, n);
    return o.renderElement({
      children: i.map(function (t, n) {
        return e.createElement(e.Fragment, {
          key: n
        }, o.renderItemElement({
          children: t
        }));
      }),
      element: {
        url: t.url
      }
    });
  }

  var l = C(t, n, r),
      c = n.filter(function (e) {
    return "Block" === e.type;
  }).find(function (e) {
    return t.type === e.name;
  });
  return c ? c.renderElement({
    children: l,
    element: {
      url: t.url
    }
  }) : r ? r({
    children: l,
    element: {
      type: "",
      children: []
    },
    attributes: {
      ref: null
    }
  }) : l;
},
    C = function C(t, n, r) {
  var a;
  return null === (a = t.children) || void 0 === a ? void 0 : a.map(function (t, a) {
    return e.createElement(e.Fragment, {
      key: a
    }, L(t, n, r));
  });
},
    N = function N(t) {
  var n = null == t ? void 0 : t.split("\n");
  if (n) return 1 === n.length ? t : e.createElement(e.Fragment, null, n.map(function (t, n, r) {
    return "\n" === t && r.length === n + 1 || "\n" === t && r.length === n + 2 && "" === r[r.length - 1] ? e.createElement(e.Fragment, {
      key: n
    }, e.createElement("br", null), " ") : "\n" === t ? e.createElement("br", null) : e.createElement(e.Fragment, {
      key: n
    }, t);
  }));
},
    B = function B(t) {
  var r,
      a,
      o = t.renderBlock,
      i = t.placeholder,
      l = t.renderPlaceholder,
      c = t.propName,
      u = t.multiline,
      s = void 0 !== u && u,
      d = t.softLineBreak,
      p = void 0 !== d && d,
      m = n(k).values[c];
  if (null === (r = B.prototype) || void 0 === r ? void 0 : r.renderAdmin) return null === (a = B.prototype) || void 0 === a ? void 0 : a.renderAdmin({
    renderBlock: o,
    placeholder: i,
    renderPlaceholder: l,
    propName: c,
    multiline: s,
    softLineBreak: p
  });
  var f = m;
  return m ? ("string" == typeof m && (f = w.deserialize(m)), e.createElement(e.Fragment, null, f.map(function (t, n) {
    return e.createElement(e.Fragment, {
      key: n
    }, L(t, [], o));
  }))) : null;
},
    A = function A(t) {
  var r,
      a,
      o = t.renderBlock,
      i = t.placeholder,
      l = t.renderPlaceholder,
      c = t.propName,
      u = t.plugins,
      s = void 0 === u ? [] : u,
      d = t.multiline,
      p = void 0 === d || d,
      m = t.softLineBreak,
      f = void 0 === m || m,
      g = n(k).values[c];
  if (null === (r = A.prototype) || void 0 === r ? void 0 : r.renderAdmin) return null === (a = A.prototype) || void 0 === a ? void 0 : a.renderAdmin({
    renderBlock: o,
    placeholder: i,
    renderPlaceholder: l,
    propName: c,
    plugins: s,
    multiline: p,
    softLineBreak: f
  });
  var h = g;
  return g ? ("string" == typeof g && (h = w.deserialize(g)), e.createElement(e.Fragment, null, h.map(function (t, n) {
    return e.createElement(e.Fragment, {
      key: n
    }, L(t, s, o));
  }))) : null;
},
    R = e.createContext({
  appId: "",
  apiKey: "",
  bricks: {},
  pageTypes: [],
  logo: "",
  contentClassName: "",
  renderLocalLink: function renderLocalLink(t) {
    var n = t.href,
        r = t.children;
    return e.createElement("a", {
      href: n
    }, r);
  },
  navigate: function navigate() {},
  loginPath: "",
  editorPath: "",
  playgroundPath: "",
  appSettingsPath: "",
  previewPath: "",
  useCssInJs: !1,
  appRootElement: "",
  clickToEditSide: E.ClickToEditSide.BottomRight,
  responsiveBreakpoints: [],
  enableAutoSave: !0,
  disableSaveIfInvalidProps: !1,
  enablePreview: !0
}),
    D = function D(e) {
  var t, n;
  return (null === (t = D.prototype) || void 0 === t ? void 0 : t.adminConstructor) ? null === (n = D.prototype) || void 0 === n ? void 0 : n.adminConstructor(e) : {
    type: "Mark",
    name: e.name,
    label: e.label || e.name[0].toUpperCase() + e.name.slice(1),
    hotKey: e.hotKey,
    renderLeaf: e.render,
    toggle: function toggle(e) {}
  };
},
    O = D({
  name: "bold",
  hotKey: "mod+b",
  render: function render(t) {
    return e.createElement("strong", null, t.children);
  }
}),
    F = D({
  name: "italic",
  hotKey: "mod+i",
  render: function render(t) {
    return e.createElement("em", null, t.children);
  }
}),
    H = D({
  name: "code",
  hotKey: "mod+`",
  render: function render(t) {
    return e.createElement("code", {
      style: {
        margin: "0 1px",
        display: "inline-block",
        padding: "3px 6px",
        fontSize: "0.875rem",
        lineHeight: 1.25,
        maxWidth: "100%",
        fontFamily: 'Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
        borderRadius: "3px",
        backgroundColor: "#F5F7F9"
      }
    }, t.children);
  }
}),
    z = D({
  name: "highlight",
  hotKey: "mod+h",
  render: function render(t) {
    return e.createElement("mark", {
      style: {
        paddingLeft: 4,
        paddingRight: 4,
        borderRadius: 2,
        backgroundColor: "#ff0",
        color: "#0f0f05"
      }
    }, t.children);
  }
}),
    j = function j(t) {
  var r,
      a,
      o = t.href,
      i = t.children,
      l = t.target,
      c = t.className,
      u = f(t, ["href", "children", "target", "className"]),
      s = n(R).renderLocalLink;
  if (null === (r = j.prototype) || void 0 === r ? void 0 : r.renderAdmin) return null === (a = j.prototype) || void 0 === a ? void 0 : a.renderAdmin(_m({
    href: o,
    children: i,
    target: l,
    className: c
  }, u));
  var d = {
    href: o
  };
  return /^\/(?!\/)/.test(o) ? s ? s(_m({
    href: o,
    target: l,
    children: i,
    className: c
  }, u)) : (s || console.warn("Local path found in Link, but no renderLocalLink function was provided. Rendering <a> as fallback"), e.createElement("a", _m({}, d, {
    target: l,
    className: c
  }, u), i)) : e.createElement("a", _m({}, d, {
    target: l,
    className: c
  }, u), i);
},
    K = {
  type: "Block",
  name: "link",
  label: "Link",
  isInline: !0,
  renderElement: function renderElement(t) {
    var n = t.attributes,
        r = t.children,
        a = t.element;
    return e.createElement(j, _m({}, n, {
      href: a.url
    }), r);
  },
  toggle: function toggle(e) {}
},
    M = function M(e) {
  var t, n;
  return (null === (t = M.prototype) || void 0 === t ? void 0 : t.adminConstructor) ? null === (n = M.prototype) || void 0 === n ? void 0 : n.adminConstructor(e) : {
    type: e.itemName ? "List" : "Block",
    name: e.name,
    isInline: e.isInline,
    itemName: e.itemName,
    label: e.label || e.name[0].toUpperCase() + e.name.slice(1),
    hotKey: e.hotKey,
    renderElement: e.render,
    renderItemElement: e.renderItem,
    toggle: function toggle(e, t) {}
  };
},
    U = M({
  name: "h1",
  hotKey: "mod+shift+1",
  render: function render(t) {
    return e.createElement("h1", null, t.children);
  }
}),
    _ = M({
  name: "h2",
  hotKey: "mod+shift+2",
  render: function render(t) {
    return e.createElement("h2", null, t.children);
  }
}),
    G = M({
  name: "h3",
  hotKey: "mod+shift+3",
  render: function render(t) {
    return e.createElement("h3", null, t.children);
  }
}),
    W = M({
  name: "h4",
  hotKey: "mod+shift+4",
  render: function render(t) {
    return e.createElement("h4", null, t.children);
  }
}),
    V = M({
  name: "h5",
  hotKey: "mod+shift+5",
  render: function render(t) {
    return e.createElement("h5", null, t.children);
  }
}),
    q = M({
  name: "h6",
  hotKey: "mod+shift+6",
  render: function render(t) {
    return e.createElement("h6", null, t.children);
  }
}),
    Q = M({
  name: "quote",
  render: function render(t) {
    return e.createElement("blockquote", null, t.children);
  }
}),
    J = M({
  name: "ol",
  label: "Number list",
  itemName: "li",
  render: function render(t) {
    return e.createElement("ol", {
      className: "list-decimal"
    }, t.children);
  },
  renderItem: function renderItem(t) {
    return e.createElement("li", null, t.children);
  }
}),
    X = M({
  name: "ul",
  label: "Bullet list",
  itemName: "li",
  render: function render(t) {
    return e.createElement("ul", {
      className: "list-disc"
    }, t.children);
  },
  renderItem: function renderItem(t) {
    return e.createElement("li", null, t.children);
  }
}),
    Y = Object.freeze({
  __proto__: null,
  bold: O,
  italic: F,
  code: H,
  highlight: z,
  link: K,
  heading1: U,
  heading2: _,
  heading3: G,
  heading4: W,
  heading5: V,
  heading6: q,
  quote: Q,
  orderedList: J,
  unorderedList: X
}),
    Z = ((I = {})[E.RichTextFeatures.Bold] = {
  newPlugin: O,
  renderLeaf: "renderBold"
}, I[E.RichTextFeatures.Italic] = {
  newPlugin: F,
  renderLeaf: "renderItalic"
}, I[E.RichTextFeatures.Highlight] = {
  newPlugin: z,
  renderLeaf: "renderHighlight"
}, I[E.RichTextFeatures.Code] = {
  newPlugin: H,
  renderLeaf: "renderCode"
}, I[E.RichTextFeatures.Link] = {
  newPlugin: K,
  renderLink: "renderLink"
}, I[E.RichTextFeatures.UnorderedList] = {
  newPlugin: X,
  renderElement: "renderUL",
  renderItemElement: "renderLI"
}, I[E.RichTextFeatures.OrderedList] = {
  newPlugin: J,
  renderElement: "renderOL",
  renderItemElement: "renderLI"
}, I[E.RichTextFeatures.Heading1] = {
  newPlugin: U,
  renderElement: "renderH1"
}, I[E.RichTextFeatures.Heading2] = {
  newPlugin: _,
  renderElement: "renderH2"
}, I[E.RichTextFeatures.Heading3] = {
  newPlugin: G,
  renderElement: "renderH3"
}, I[E.RichTextFeatures.Heading4] = {
  newPlugin: W,
  renderElement: "renderH4"
}, I[E.RichTextFeatures.Heading5] = {
  newPlugin: V,
  renderElement: "renderH5"
}, I[E.RichTextFeatures.Heading6] = {
  newPlugin: q,
  renderElement: "renderH6"
}, I[E.RichTextFeatures.Quote] = {
  newPlugin: Q,
  renderElement: "renderQuote"
}, I),
    $ = function $(e) {
  var n, r;
  if (null === (n = $.prototype) || void 0 === n ? void 0 : n.renderAdmin) return null === (r = $.prototype) || void 0 === r ? void 0 : r.renderAdmin(e);
  var a = [];
  return e.allowedFeatures && e.allowedFeatures.length > 0 && (a = e.allowedFeatures.map(function (t) {
    var n = Z[t],
        r = n.newPlugin,
        a = n.renderLeaf,
        o = n.renderElement,
        i = n.renderItemElement,
        l = n.renderLink,
        c = {},
        u = e[a],
        s = e[o],
        d = e[i],
        p = e[l];
    return a && u && (c.renderLeaf = u), o && s && (c.renderElement = s), i && d && (c.renderItemElement = d), l && p && (c.renderElement = function (e) {
      var t = e.attributes,
          n = e.children,
          r = e.element;
      return p({
        attributes: t,
        children: n,
        element: r,
        href: r.url
      });
    }), _m(_m({}, r), c);
  })), t.createElement(A, {
    renderBlock: e.renderBlock,
    placeholder: e.placeholder,
    propName: e.propName,
    plugins: a,
    multiline: e.multiline
  });
},
    ee = require("react-progressive-graceful-image").default,
    te = function te(e, t) {
  if (!t) return e;
  var n = e.lastIndexOf(".");
  return e.substring(0, n) + "/" + t + e.substring(n);
},
    ne = function ne(t) {
  t.propName;
  var n = t.source,
      r = t.alt,
      a = t.noLazyLoad,
      o = void 0 !== a && a,
      i = t.containerClassName,
      l = t.containerStyle,
      c = void 0 === l ? {} : l,
      u = t.imageClassName,
      s = t.imageStyle,
      d = void 0 === s ? {} : s,
      p = t.noWrapper,
      g = void 0 !== p && p,
      h = f(t, ["propName", "source", "alt", "noLazyLoad", "containerClassName", "containerStyle", "imageClassName", "imageStyle", "noWrapper"]),
      v = (null == n ? void 0 : n.alt) || r;
  if (!n) return null;
  var b,
      E,
      k = te(n.src, n.seoName),
      T = te(n.placeholderSrc || "", n.seoName),
      x = (b = n.srcSet, E = n.seoName, b ? E ? b.split(",").map(function (e) {
    var t = y(e.trim().split(" "), 2),
        n = t[0],
        r = t[1];
    return n && r ? "".concat(te(n, E), " ").concat(r) : te(e, E);
  }).join(", ") : b : "");
  return o ? e.createElement("div", {
    className: i,
    style: c
  }, e.createElement("img", _m({
    src: k,
    srcSet: x,
    alt: v,
    className: u,
    style: c
  }, h))) : g ? e.createElement(ee, {
    src: k,
    srcSetData: {
      srcSet: x
    },
    placeholder: ""
  }, function (t, n, r) {
    return n ? e.createElement("img", {
      src: T,
      alt: v,
      className: u,
      style: _m({
        filter: "blur(8px)"
      }, d)
    }) : e.createElement("img", _m({
      src: t,
      srcSet: r.srcSet,
      alt: v,
      className: u,
      style: d
    }, h));
  }) : e.createElement("div", {
    className: i,
    style: c
  }, e.createElement(ee, {
    src: k,
    srcSetData: {
      srcSet: x
    },
    placeholder: ""
  }, function (t, n, r) {
    return n ? e.createElement("img", {
      src: T,
      alt: v,
      className: u,
      style: _m({
        filter: "blur(8px)"
      }, d)
    }) : e.createElement("img", _m({
      src: t,
      srcSet: r.srcSet,
      alt: v,
      className: u,
      style: d
    }, h));
  }));
},
    re = function re(t) {
  var r,
      a,
      o = n(k).values[t.propName];
  if (null === (r = re.prototype) || void 0 === r ? void 0 : r.renderAdmin) return null === (a = re.prototype) || void 0 === a ? void 0 : a.renderAdmin(t);
  t.maxWidth, t.aspectRatio;
  var i = f(t, ["maxWidth", "aspectRatio"]);
  return e.createElement(ne, _m({}, i, {
    source: o
  }));
},
    ae = function ae(e) {
  var t,
      r = e.allowedExtensions,
      a = void 0 === r ? [] : r,
      o = e.propName,
      i = e.renderBlock,
      l = n(k).values[o];
  return (null === (t = ae.prototype) || void 0 === t ? void 0 : t.renderAdmin) ? ae.prototype.renderAdmin({
    propName: o,
    renderBlock: i,
    allowedExtensions: a
  }) : l ? i(l) : null;
},
    oe = function oe(t) {
  var a,
      o,
      i = t.propName,
      l = t.itemProps,
      c = void 0 === l ? {} : l,
      u = t.renderWrapper,
      s = t.renderItemWrapper,
      d = n(R).bricks,
      p = n(k),
      f = p.values,
      g = p.parentId,
      h = p.parentType,
      v = p.handleChange,
      y = p.handleAddItem,
      b = f[i];
  if (r(function () {
    var e,
        t,
        n = null === (t = null === (e = d[h].schema) || void 0 === e ? void 0 : e.repeaterItems) || void 0 === t ? void 0 : t.find(function (e) {
      return e.name === i;
    });
    n && n.min && (!b || b.length < n.min) && y && y(g, i, n.itemType)();
  }, [g, i, b]), null === (a = oe.prototype) || void 0 === a ? void 0 : a.renderAdmin) return null === (o = oe.prototype) || void 0 === o ? void 0 : o.renderAdmin({
    propName: i,
    itemProps: c,
    renderWrapper: u,
    renderItemWrapper: s
  });
  if (!b || 0 === b.length) return null;
  var E = e.createElement(e.Fragment, null, b.map(function (t, n) {
    var r = d[t.type];

    if (r) {
      var a = r.schema.sideEditProps ? r.schema.sideEditProps.reduce(function (e, n) {
        var r, a;
        return n.groupName ? a = n.props.map(function (e) {
          var n;
          return (n = {})[e.name] = t.props[e.name], n;
        }).reduce(function (e, t) {
          return _m(_m({}, e), t);
        }, {}) : ((r = {})[n.name] = t.props[n.name], a = r), _m(_m({}, e), a);
      }, {}) : {},
          o = _m(_m(_m({}, a), c), {
        key: t.id,
        index: n,
        onClick: function onClick(e) {},
        onFocus: function onFocus(e) {},
        onChange: function onChange() {}
      }),
          l = e.createElement(k.Provider, {
        key: t.id,
        value: {
          onChange: v(t.id, g, i),
          values: t.props,
          blockId: t.id,
          parentId: g,
          parentType: h,
          handleChange: v
        }
      }, e.createElement(r, _m({}, o)));

      return s ? s(l, n, b.length) : l;
    }
  }));
  return u ? u(E) : E;
},
    ie = function ie() {
  var e, t;
  return (null === (e = ie.prototype) || void 0 === e ? void 0 : e.useAdmin) ? null === (t = ie.prototype) || void 0 === t ? void 0 : t.useAdmin() : {
    isAdmin: !1,
    previewMode: !1,
    currentPage: {
      pageId: ""
    }
  };
},
    le = function le(e) {
  var t,
      r,
      a = n(k),
      o = a.values,
      i = a.onChange;
  if (null === (t = le.prototype) || void 0 === t ? void 0 : t.useAdmin) return null === (r = le.prototype) || void 0 === r ? void 0 : r.useAdmin(e);
  return [o[e], function (t) {
    return i(e, t);
  }, !0];
},
    ce = function ce() {
  return e.createElement("div", {
    className: o("max-w-xl mx-auto py-6")
  });
};

ce.schema = {
  name: "paragraph",
  label: "Paragraph",
  getDefaultProps: function getDefaultProps() {
    return {
      text: "Lorem ipsum dolor sit amet"
    };
  }
};

var ue = {
  paragraph: ce
},
    se = [{
  type: E.DeviceType.Phone,
  width: 375,
  label: "Phone (375px)"
}, {
  type: E.DeviceType.Tablet,
  width: 768,
  label: "Tablet (768px)"
}, {
  type: E.DeviceType.Desktop,
  width: "100%",
  label: "Desktop (100%)"
}],
    de = new i(),
    pe = [{
  name: "page",
  pluralName: "pages",
  defaultLocked: !1,
  defaultStatus: E.PageStatus.Draft,
  defaultLanguage: "en",
  getDefaultContent: function getDefaultContent() {
    return [];
  }
}],
    me = function me(t) {
  var n = t.appId,
      r = t.apiKey,
      a = t.bricks,
      o = t.pageTypes,
      i = t.customFields,
      c = t.logo,
      u = void 0 === c ? "" : c,
      s = t.contentClassName,
      d = void 0 === s ? "" : s,
      p = t.renderLocalLink,
      f = t.navigate,
      g = t.loginPath,
      h = void 0 === g ? "/admin" : g,
      v = t.editorPath,
      y = void 0 === v ? "/admin/editor" : v,
      b = t.playgroundPath,
      k = void 0 === b ? "/admin/playground" : b,
      T = t.appSettingsPath,
      x = void 0 === T ? "/admin/app-settings" : T,
      P = t.previewPath,
      S = void 0 === P ? "/preview" : P,
      I = t.isDarkColorMode,
      w = void 0 !== I && I,
      L = t.toggleColorMode,
      C = t.useCssInJs,
      N = void 0 !== C && C,
      B = t.appRootElement,
      A = t.clickToEditSide,
      D = void 0 === A ? E.ClickToEditSide.BottomRight : A,
      O = t.responsiveBreakpoints,
      F = t.enableAutoSave,
      H = void 0 === F || F,
      z = t.disableSaveIfInvalidProps,
      j = void 0 !== z && z,
      K = t.enablePreview,
      M = void 0 === K || K,
      U = t.children,
      _ = !1;

  if (a && 0 !== a.length || console.warn("No bricks provided. Using default paragraph."), o || console.warn("No Page type schema provided. Using default page."), Array.isArray(a) || (console.error('"bricks" should be an array of Bricks'), _ = !0), null == o || o.forEach(function (e) {
    e.getDefaultContent && e.getDefaultContent().length > 0 && "string" != typeof e.getDefaultContent()[0] && console.error("A page type getDefaultContent() must return an array of bricks' names: please check the ".concat(e.name, " page type."));
  }), a && a.forEach(function (e) {
    e.schema ? (e.schema.render && console.warn('The "render" method is depreacted on React Bricks v2 bricks. Please check the '.concat(name, " brick.")), e.schema.superType && console.warn('The "superType" property is depreacted on React Bricks v2 bricks. Please check the '.concat(name, " brick.")), e.schema.textEditProps && console.warn('The "textEditProps" property is depreacted on React Bricks v2 bricks. Please check the '.concat(name, " brick."))) : (console.error('Each brick component must have a "schema" property. Please check the '.concat(name, " brick.")), _ = !0);
  }), _) return e.createElement("div", {
    style: {
      padding: "8px 16px",
      backgroundColor: "#fff5f5",
      border: "1px solid #fed7d7",
      borderRadius: 4,
      color: "#c53030",
      margin: "50px auto",
      width: 300
    }
  }, "At least a blocking error found in schema. Check the console.");
  var G = null == a ? void 0 : a.reduce(function (e, t) {
    var n;
    return _m(_m({}, e), ((n = {})[t.schema.name] = t, n));
  }, {}),
      W = O && O.length ? O : se;
  return e.createElement(R.Provider, {
    value: {
      appId: n,
      apiKey: r,
      bricks: G || ue,
      pageTypes: o || pe,
      customFields: i,
      logo: u,
      contentClassName: d,
      renderLocalLink: p,
      navigate: f,
      loginPath: h,
      editorPath: y,
      playgroundPath: k,
      appSettingsPath: x,
      previewPath: S,
      isDarkColorMode: w,
      toggleColorMode: L,
      useCssInJs: N,
      appRootElement: B,
      clickToEditSide: D,
      responsiveBreakpoints: W,
      enableAutoSave: !!H,
      disableSaveIfInvalidProps: !!j,
      enablePreview: !!M
    }
  }, e.createElement(l, {
    client: de
  }, U));
},
    fe = e.createContext({
  pageValues: {
    id: "",
    type: "",
    name: "",
    slug: "",
    meta: {},
    authorId: "",
    author: {
      id: "",
      email: "",
      firstName: "",
      lastName: ""
    },
    invalidBlocksTypes: [],
    status: E.PageStatus.Draft,
    isLocked: !1,
    tags: [],
    createdAt: "",
    publishedAt: "",
    language: "",
    translations: []
  }
}),
    ge = function ge() {
  var e = n(T),
      t = e.pageValues,
      r = e.handleChangePageValue,
      a = n(fe).pageValues;
  return [t.id ? t : a, r];
},
    he = function he(t) {
  var n = t.bricks,
      r = t.block;
  return e.createElement(e.Fragment, null, function (t) {
    var r = n[t.type],
        a = y(ge(), 1)[0];

    if (r) {
      var o = t.props;
      return r.schema.mapExternalDataToProps && "function" == typeof r.schema.mapExternalDataToProps && a.externalData && "object" == typeof a.externalData && (o = r.schema.mapExternalDataToProps(a.externalData, t.props)), e.createElement(k.Provider, {
        value: {
          values: o,
          onChange: function onChange() {},
          blockId: t.id,
          parentId: t.id,
          parentType: t.type,
          handleChange: function handleChange(e) {
            return function () {};
          },
          handleAddItem: function handleAddItem(e) {
            return function () {};
          }
        }
      }, e.createElement(r, _m({}, o)));
    }
  }(r));
},
    ve = function ve(t) {
  var n = t.bricks,
      r = t.content;
  return e.createElement("div", null, r.map(function (t) {
    return e.createElement(he, {
      key: t.id,
      bricks: n,
      block: t
    });
  }));
},
    ye = "https://api.reactbricks.com/v2",
    be = "rb_t",
    Ee = function Ee(e) {
  var o = e.pageId,
      i = e.language,
      l = n(R),
      c = l.navigate,
      s = l.editorPath,
      d = l.clickToEditSide,
      p = y(a(!1), 2),
      m = p[0],
      f = p[1];
  if (r(function () {
    f(!0);
  }, []), !m) return null;
  var g,
      h = localStorage.getItem("rb_t");

  if (h && h.length > 10 && h.startsWith("ey")) {
    var v = {};
    return d === E.ClickToEditSide.BottomRight && (v.bottom = 50, v.right = 0, v.borderTopLeftRadius = 999, v.borderBottomLeftRadius = 999, v.transform = "translate(8px,0)"), d === E.ClickToEditSide.BottomLeft && (v.bottom = 50, v.left = 0, v.borderTopRightRadius = 999, v.borderBottomRightRadius = 999, v.transform = "translate(-8px,0)"), d === E.ClickToEditSide.TopRight && (v.top = 50, v.right = 0, v.borderTopLeftRadius = 999, v.borderBottomLeftRadius = 999, v.transform = "translate(8px,0)"), d === E.ClickToEditSide.TopLeft && (v.top = 50, v.left = 0, v.borderTopRightRadius = 999, v.borderBottomRightRadius = 999, v.transform = "translate(-8px,0)"), t.createElement(t.Fragment, null, t.createElement("style", null, "\n.rb-click-to-edit {\n  position: fixed;\n  width: 61px;\n  height: 38px;\n  background-color: #f65a8e;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  font-size: 20px;\n  cursor: pointer;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  transition: all 150ms ease;\n  border: 2px solid #fff;\n}\n.rb-click-to-edit-left:hover {\n  transform: translate(-2px,0)!important;\n}\n.rb-click-to-edit-right:hover {\n  transform: translate(2px,0)!important;\n}\n      "), t.createElement("div", {
      className: "rb-click-to-edit ".concat((g = d, g === E.ClickToEditSide.TopLeft || g === E.ClickToEditSide.BottomLeft ? "rb-click-to-edit-left" : "rb-click-to-edit-right")),
      style: v,
      onClick: function onClick() {
        return c("".concat(s, "?p=").concat(encodeURIComponent(o), "&l=").concat(i));
      }
    }, t.createElement(u, null)));
  }

  return null;
},
    ke = function ke(t) {
  var r = t.page;
  if (!r) return null;
  var a = n(R).bricks;
  r.content;

  var o = f(r, ["content"]),
      i = _m({}, o);

  return e.createElement("div", null, r && r.content && r.content.length > 0 && e.createElement(fe.Provider, {
    value: {
      pageValues: i
    }
  }, e.createElement(ve, {
    bricks: a,
    content: r.content
  }), e.createElement(Ee, {
    pageId: r.id,
    language: r.language
  })));
},
    Te = function Te(e, t, n) {
  return !(n && n.find(function (t) {
    return t === e;
  }) || t && !t.find(function (t) {
    return t === e;
  }));
},
    xe = {
  id: "",
  type: "",
  slug: "",
  name: "",
  meta: {},
  author: {
    id: "",
    firstName: "",
    lastName: "",
    email: ""
  },
  status: E.PageStatus.Draft,
  isLocked: !1,
  content: [],
  tags: [],
  createdAt: "",
  language: "en",
  translations: []
},
    Pe = function Pe(e, t, n) {
  if (!e || !e.type || !e.content) return xe;
  var r = t.find(function (t) {
    return t.name === e.type;
  });
  if (!r) return xe;
  var a = Se(n, e.content, r.allowedBlockTypes, r.excludedBlockTypes);
  return _m(_m({}, e), {
    content: a.blocks,
    invalidBlocksTypes: a.invalidBlocksTypes
  });
},
    Se = function Se(e, t, n, r) {
  return t.reduce(function (t, a) {
    var o = e[a.type];
    if (!o || !Te(a.type, n, r)) return _m(_m({}, t), {
      invalidBlocksTypes: b(b([], y(t.invalidBlocksTypes), !1), [a.type], !1)
    });

    var i = o.schema.sideEditProps ? o.schema.sideEditProps.reduce(function (e, t) {
      if (t.groupName || "BOOLEAN" !== t.type || e.push(t), t.groupName) {
        var n = t.props.filter(function (e) {
          return "BOOLEAN" === e.type;
        });
        e = b(b([], y(e), !1), y(n), !1);
      }

      return e;
    }, []) : [],
        l = i.reduce(function (e, t) {
      var n,
          r = a.props[t.name];
      return _m(_m({}, e), ((n = {})[t.name] = !!r, n));
    }, {}),
        c = _m(_m({}, a), {
      props: _m(_m({}, a.props), l)
    });

    return Object.keys(c.props).forEach(function (t) {
      var n, r, a, i, l, u, s;
      c.props[t] && (null === (r = null === (n = c.props[t]) || void 0 === n ? void 0 : n.document) || void 0 === r ? void 0 : r.data) && (null === (i = null === (a = c.props[t]) || void 0 === a ? void 0 : a.document) || void 0 === i ? void 0 : i.nodes) && "document" === (null === (u = null === (l = c.props[t]) || void 0 === l ? void 0 : l.document) || void 0 === u ? void 0 : u.object) || (null === (s = o.schema.repeaterItems) || void 0 === s ? void 0 : s.find(function (e) {
        return e.name === t;
      })) && (c.props[t] = Se(e, c.props[t]).blocks);
    }), _m(_m({}, t), {
      blocks: b(b([], y(t.blocks), !1), [c], !1)
    });
  }, {
    blocks: [],
    invalidBlocksTypes: []
  });
},
    Ie = function Ie() {
  var t = y(a(), 2),
      o = t[0],
      i = t[1],
      l = n(R),
      c = l.bricks,
      u = l.pageTypes;
  if (r(function () {
    g(void 0, void 0, void 0, function () {
      var e, t, n, r, a, o;
      return h(this, function (l) {
        switch (l.label) {
          case 0:
            return (e = new URLSearchParams(window.location.search)).has("p") ? (t = encodeURIComponent(e.get("p") || ""), [4, s.get("".concat(ye, "/app/preview/").concat(t))]) : [3, 4];

          case 1:
            return n = l.sent().data, r = null, (null == (a = null == u ? void 0 : u.find(function (e) {
              return e.name === n.type;
            })) ? void 0 : a.getExternalData) && "function" == typeof a.getExternalData ? [4, a.getExternalData(n)] : [3, 3];

          case 2:
            (r = l.sent()) && "object" == typeof r && (n.externalData = r), l.label = 3;

          case 3:
            o = Pe(n, u, c), i(o), l.label = 4;

          case 4:
            return [2];
        }
      });
    });
  }, []), !o) return null;
  o.content;

  var d = f(o, ["content"]),
      p = _m({}, d);

  return e.createElement("div", null, o && o.content && o.content.length > 0 && e.createElement(fe.Provider, {
    value: {
      pageValues: p
    }
  }, e.createElement(ve, {
    bricks: c,
    content: o.content
  })));
},
    we = function we(e) {
  if ("undefined" == typeof window) return null;
  e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var t = new RegExp("[\\?&]" + e + "=([^&#]*)").exec(window.location.search);
  return null === t ? "" : decodeURIComponent(t[1].replace(/\+/g, " "));
},
    Le = function Le(e) {
  var t = void 0 === e ? {} : e,
      n = t.type,
      r = void 0 === n ? "" : n,
      a = t.types,
      o = void 0 === a ? [] : a,
      i = t.tag,
      l = void 0 === i ? "" : i,
      u = t.language,
      d = void 0 === u ? "" : u,
      p = t.page,
      m = void 0 === p ? 1 : p,
      f = t.pageSize,
      v = void 0 === f ? 500 : f,
      y = t.sort,
      b = void 0 === y ? "" : y,
      E = t.usePagination,
      k = void 0 !== E && E;
  v <= 0 && (v = 500);
  var T = localStorage.getItem("rb_t"),
      x = we("t"),
      P = "type=".concat(r, "&types=").concat(null == o ? void 0 : o.join(","), "&tag=").concat(l, "&language=").concat(d, "&page=").concat(m, "&pageSize=").concat(v, "&sort=").concat(b);
  return c(["pages", {
    pageType: r,
    pageTypes: o,
    tag: l,
    language: d,
    page: m,
    pageSize: v,
    sort: b
  }], function () {
    return g(void 0, void 0, void 0, function () {
      var e, t, n, r;
      return h(this, function (a) {
        switch (a.label) {
          case 0:
            return [4, s.get("".concat(ye, "/admin/pages?").concat(P))];

          case 1:
            return e = a.sent(), t = e.data, n = e.headers, k ? (r = n["x-total-count"] ? parseInt(n["x-total-count"], 10) : 0, [2, {
              items: t,
              pagination: {
                page: m,
                pageSize: v,
                totalItems: r,
                totalPages: Math.ceil(r / v)
              }
            }]) : [2, t];
        }
      });
    });
  }, {
    enabled: !!T || !!x
  });
},
    Ce = function Ce(e, t) {
  var r = n(R).pageTypes,
      a = localStorage.getItem("rb_t"),
      o = we("t");
  return c(["page", {
    pageId: e,
    language: t
  }], function () {
    return g(void 0, void 0, Promise, function () {
      var n, i, l;
      return h(this, function (c) {
        switch (c.label) {
          case 0:
            return [4, s.get(t ? "".concat(ye, "/admin/pages/").concat(e, "/translations/").concat(t) : "".concat(ye, "/admin/pages/").concat(e), {
              headers: {
                Authorization: "Bearer ".concat(a || o)
              }
            })];

          case 1:
            return n = c.sent().data, i = null, (null == (l = null == r ? void 0 : r.find(function (e) {
              return e.name === n.type;
            })) ? void 0 : l.getExternalData) && "function" == typeof l.getExternalData ? [4, l.getExternalData(n)] : [3, 3];

          case 2:
            (i = c.sent()) && "object" == typeof i && (n.externalData = i), c.label = 3;

          case 3:
            return [2, n];
        }
      });
    });
  }, {
    enabled: !(!e || !a && !o),
    refetchOnWindowFocus: !1
  });
},
    Ne = function Ne(e, t) {
  var r = n(R),
      a = r.apiKey,
      o = r.pageTypes;
  return c(["pagePublic", {
    slug: e,
    language: t
  }], function () {
    return g(void 0, void 0, Promise, function () {
      var n, r, i;
      return h(this, function (l) {
        switch (l.label) {
          case 0:
            return [4, s.get(t ? "".concat(ye, "/app/pages/").concat(e, "/translations/").concat(t) : "".concat(ye, "/app/pages/").concat(e), {
              headers: {
                Authorization: "Bearer ".concat(a)
              }
            })];

          case 1:
            return n = l.sent().data, r = null, (null == (i = null == o ? void 0 : o.find(function (e) {
              return e.name === n.type;
            })) ? void 0 : i.getExternalData) && "function" == typeof i.getExternalData ? [4, i.getExternalData(n)] : [3, 3];

          case 2:
            (r = l.sent()) && "object" == typeof r && (n.externalData = r), l.label = 3;

          case 3:
            return [2, n];
        }
      });
    });
  }, {
    enabled: !!e
  });
},
    Be = function Be(e) {
  var t = void 0 === e ? {} : e,
      r = t.type,
      a = void 0 === r ? "" : r,
      o = t.types,
      i = void 0 === o ? [] : o,
      l = t.tag,
      u = void 0 === l ? "" : l,
      d = t.language,
      p = void 0 === d ? "" : d,
      m = t.page,
      f = void 0 === m ? 1 : m,
      v = t.pageSize,
      y = void 0 === v ? 100 : v,
      b = t.sort,
      E = void 0 === b ? "" : b,
      k = t.usePagination,
      T = void 0 !== k && k,
      x = n(R).apiKey;
  y <= 0 && (y = 100);
  var P = "type=".concat(a, "&types=").concat(null == i ? void 0 : i.join(","), "&tag=").concat(u, "&language=").concat(p, "&page=").concat(f, "&pageSize=").concat(y, "&sort=").concat(E);
  return c(["pagesPublic", {
    pageType: a,
    pageTypes: i,
    tag: u,
    page: f,
    pageSize: y,
    sort: E
  }], function () {
    return g(void 0, void 0, void 0, function () {
      var e, t, n, r;
      return h(this, function (a) {
        switch (a.label) {
          case 0:
            return [4, s.get("".concat(ye, "/app/pages?").concat(P), {
              headers: {
                Authorization: "Bearer ".concat(x)
              }
            })];

          case 1:
            return e = a.sent(), t = e.data, n = e.headers, T ? (r = n["x-total-count"] ? parseInt(n["x-total-count"], 10) : 0, [2, {
              items: t,
              pagination: {
                page: f,
                pageSize: y,
                totalItems: r,
                totalPages: Math.ceil(r / y)
              }
            }]) : [2, t];
        }
      });
    });
  });
},
    Ae = function Ae(e, t) {
  void 0 === e && (e = 1), void 0 === t && (t = 100);
  var r = n(R).apiKey;
  return c(["tagsPublic"], function () {
    return g(void 0, void 0, void 0, function () {
      var n, a, o, i;
      return h(this, function (l) {
        switch (l.label) {
          case 0:
            return [4, s.get("".concat(ye, "/app/tags?pageSize=").concat(t, "&page=").concat(e), {
              headers: {
                Authorization: "Bearer ".concat(r)
              }
            })];

          case 1:
            return n = l.sent(), a = n.data, o = n.headers, i = o["x-total-count"] ? parseInt(o["x-total-count"], 10) : 0, [2, {
              items: a,
              pagination: {
                page: e,
                pageSize: t,
                totalItems: i,
                totalPages: Math.ceil(i / t)
              }
            }];
        }
      });
    });
  }, {
    staleTime: 3e5
  });
},
    Re = function Re() {
  return n(R);
},
    De = function De(e, t, n, r) {
  return g(void 0, void 0, Promise, function () {
    var a, o, i, l;
    return h(this, function (c) {
      switch (c.label) {
        case 0:
          return a = n ? "/translations/".concat(n) : "", [4, s.get("".concat(ye, "/app/pages/").concat(e).concat(a), {
            headers: {
              Authorization: "Bearer ".concat(t)
            }
          })];

        case 1:
          return o = c.sent().data, i = null, (null == (l = null == r ? void 0 : r.find(function (e) {
            return e.name === o.type;
          })) ? void 0 : l.getExternalData) && "function" == typeof l.getExternalData ? [4, l.getExternalData(o)] : [3, 3];

        case 2:
          (i = c.sent()) && "object" == typeof i && (o.externalData = i), c.label = 3;

        case 3:
          return [2, o];
      }
    });
  });
},
    Oe = function Oe(e, t) {
  var n = void 0 === t ? {} : t,
      r = n.type,
      a = void 0 === r ? "" : r,
      o = n.types,
      i = void 0 === o ? [] : o,
      l = n.tag,
      c = void 0 === l ? "" : l,
      u = n.language,
      d = void 0 === u ? "" : u,
      p = n.page,
      m = void 0 === p ? 1 : p,
      f = n.pageSize,
      v = void 0 === f ? 100 : f,
      y = n.sort,
      b = void 0 === y ? "" : y,
      E = n.usePagination,
      k = void 0 !== E && E;
  return g(void 0, void 0, void 0, function () {
    var t, n, r, o, l;
    return h(this, function (u) {
      switch (u.label) {
        case 0:
          return v <= 0 && (v = 100), t = "type=".concat(a, "&types=").concat(null == i ? void 0 : i.join(","), "&tag=").concat(c, "&language=").concat(d, "&page=").concat(m, "&pageSize=").concat(v, "&sort=").concat(b), [4, s.get("".concat(ye, "/app/pages?").concat(t), {
            headers: {
              Authorization: "Bearer ".concat(e)
            }
          })];

        case 1:
          return n = u.sent(), r = n.data, o = n.headers, k ? (l = o["x-total-count"] ? parseInt(o["x-total-count"], 10) : 0, [2, {
            items: r,
            pagination: {
              page: m,
              pageSize: v,
              totalItems: l,
              totalPages: Math.ceil(l / v)
            }
          }]) : [2, r];
      }
    });
  });
},
    Fe = function Fe(e, t, n) {
  return void 0 === t && (t = 1), void 0 === n && (n = 100), g(void 0, void 0, Promise, function () {
    var r, a, o, i;
    return h(this, function (l) {
      switch (l.label) {
        case 0:
          return [4, s.get("".concat(ye, "/app/tags?pageSize=").concat(n, "&page=").concat(t), {
            headers: {
              Authorization: "Bearer ".concat(e)
            }
          })];

        case 1:
          return r = l.sent(), a = r.data, o = r.headers, i = o["x-total-count"] ? parseInt(o["x-total-count"], 10) : 0, [2, {
            items: a,
            pagination: {
              page: t,
              pageSize: n,
              totalItems: i,
              totalPages: Math.ceil(i / n)
            }
          }];
      }
    });
  });
},
    He = function He(e) {
  return e.reduce(function (e, t) {
    var n = [];

    for (var r in t.props) {
      Array.isArray(t.props[r]) && t.props[r].length > 0 && t.props[r][0].props ? n.push.apply(n, b([], y(He(t.props[r])), !1)) : n.push(w.serialize(t.props[r]));
    }

    return b(b([], y(e), !1), y(n), !1);
  }, []);
};

export { be as A, k as B, T as C, ke as D, xe as E, ae as F, Ie as G, Ne as H, re as I, Be as J, Ae as K, j as L, Re as M, De as N, Oe as O, w as P, Fe as Q, R, He as S, B as T, y as _, _m as a, f as b, v as c, g as d, h as e, p as f, b as g, ge as h, Te as i, we as j, Ce as k, Pe as l, Se as m, ye as n, M as o, D as p, de as q, Y as r, $ as s, E as t, Le as u, A as v, oe as w, ie as x, le as y, me as z };